import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

// ###### CARD CONTAINER COMPONENT
// Movido de finance/moduleComponents — já era genérico, sem cor de módulo hardcoded.
const CardContainer = ({
  title,
  children,
  collapsible = false,
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    if (collapsible) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow flex-1 px-4 py-2">
      <div
        className={`flex items-center justify-between min-h-0 leading-tight mb-2 ${
          collapsible ? 'cursor-pointer' : ''
        }`}
        onClick={toggleExpanded}
      >
        <h2 className="text-base font-semibold text-gray-800 leading-snug">{title}</h2>

        {collapsible && (
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700 transition-colors shrink-0 flex h-7 w-7 items-center justify-center rounded-md"
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
          >
            {isExpanded ? (
              <ChevronDownIcon className="h-4 w-4" />
            ) : (
              <ChevronRightIcon className="h-4 w-4" />
            )}
          </button>
        )}
      </div>

      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isExpanded ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default CardContainer;
